<span class="no-data-message">
    {{(message) | translate | packageTitle | hubTitle }}
</span>
